/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import {
  Div,
  Panel,
  PanelHeader,
  ScreenSpinner,
  SimpleCell,
  Text,
} from "@vkontakte/vkui";
import { SelectBox } from "../../components";
import Icon28ArrowLeftOutline from "@vkontakte/icons/dist/28/arrow_left_outline";
import {
  setActivePanel,
  setPreviousPanel,
} from "../../redux/actions/panelsActions";
import { panels } from "../../variables";
import styles from "./RegionAndMedicalOrganisation.style";
import {
  clearRegionAndMedicalOrganisation,
  selectMedicalOrganisation,
  selectRegion as selectRegionAction,
  startFirstStepLoading,
  startSecondStepLoading,
  startThirdStepLoading,
  startFourthStepLoading,
  startFifthStepLoading,
  startSixthStepLoading,
  restartSteps,
  setErrorMessage as setErrorMessageAction,
  cleanErrorMessage as cleanErrorMessageAction,
} from "../../redux/actions/regionAndMedicalOrganisationActions";
import ServiceAvailabilityMessage from "./ServiceAvailabilityMessage";

import CrossIcon from "../../img/IconColor.png";

const RegionAndMedicalOrganisation = ({
  id,
  goBack,
  goToDoctorPanel,
  errorMessage,
  setErrorMessage,
  cleanErrorMessage,
  startFirstStepLoading,
  startSecondStepLoading,
  startThirdStepLoading,
  startFourthStepLoading,
  startFifthStepLoading,
  startSixthStepLoading,
  firstStepSuccess,
  secondStepSuccess,
  thirdStepSuccess,
  fifthStepSuccess,
  sixthStepSuccess,
  userChecks,
  regions,
  selectRegion,
  selectedRegion,
  userInfo,
  user,
  orderId,
  medicalOrganisations,
  selectMedicalOrganisation,
  snils,
  showLoader,
  clearRegionAndMedicalOrganisation,
  clearMedicalOrganisationSelector,
  clearState
}) => {
  const [isFirstRender, setFirstRender] = React.useState(true);
  const isContentLoading = showLoader;

  useEffect(() => {
    clearState();
    setFirstRender(false);
  }, [])

  useEffect(() => {
    if (!firstStepSuccess) {
      clearMedicalOrganisationSelector();
      startFirstStepLoading();
    }
  }, []);

  useEffect(() => {
    if (firstStepSuccess && !thirdStepSuccess && !secondStepSuccess) {
      startSecondStepLoading();
    }
  }, [firstStepSuccess]);

  useEffect(() => {
    if (firstStepSuccess && secondStepSuccess) {
      startThirdStepLoading();
    }
  }, [secondStepSuccess]);

  useEffect(() => {
    if (!isFirstRender && selectedRegion && !errorMessage) {
      startFifthStepLoading(userInfo, selectedRegion, user, orderId, snils);
    }
  }, [selectedRegion, errorMessage]);

  useEffect(() => {
    if (!isFirstRender && selectedRegion && fifthStepSuccess) {
      startSixthStepLoading(userInfo, orderId, selectedRegion, user);
    }
  }, [userChecks, fifthStepSuccess]);

  const mapMedicalOrganisationToSimpleCell = (medicalOrganisation) => {
    return (
      <SimpleCell
        style={styles.medicalOrganisation}
        key={medicalOrganisation.MO_Id}
        onClick={() => {
          selectMedicalOrganisation(medicalOrganisation);
          goToDoctorPanel();
        }}
        description={
          <span style={styles.medicalOrganisationDesc}>
            {getShortAddress(medicalOrganisation.Address_MO)}
          </span>
        }
      >
        {getShortNameFromFull(medicalOrganisation.Organization_Name)}
      </SimpleCell>
    );
  };

  const getShortNameFromFull = (fullName) => {
    while (fullName.includes(",")) {
      fullName = fullName.replace(",", "");
    }
    const words = fullName.split(" ");
    return words.slice(0, 4).join(" ");
  };

  const getShortAddress = (address) => {
    const addressWithoutIndex = address.slice(8);
    const commaIndex = addressWithoutIndex.indexOf(",");
    return addressWithoutIndex
      .split("")
      .slice(commaIndex + 1)
      .join("");
  };
  const mapRegionOption = (region) => {
    return {
      value: region.name,
      id: region.regionCode,
    };
  };
  const selectData = regions.map(mapRegionOption);

  const cleanSelectCallback = useCallback(() => {
    clearRegionAndMedicalOrganisation();
    selectRegion(null);
    cleanErrorMessage();
  }, []);

  return (
    <Panel id={id}>
      <PanelHeader
        separator={false}
        left={
          <Div
            style={{
              margin: "0",
              padding: "0",
              display: "flex",
              justifyContent: "left",
            }}
          >
            <Icon28ArrowLeftOutline onClick={() => goBack()} fill={"#06844D"} />
            <Text
              style={{
                ...styles.headerText,
              }}
            >
              Выбор организации
            </Text>
          </Div>
        }
      />
      <Div
        style={{
          padding: "0",
          margin: "0",
          ...styles.wrapper,
        }}
      >
        <Text weight="regular" style={styles.selectorLabel}>
          Регион
        </Text>

        <Div style={styles.wrapperSelectRegion}>
          <SelectBox
            disabled={isContentLoading}
            selected={selectedRegion?.name}
            reset={!selectedRegion.regionCode}
            items={selectData}
            placeholder="Выберите регион"
            onChange={(event) => {
              cleanSelectCallback();
              let reg = null;
              let regKey = event.id;
              window.setTimeout(() => {
                if (regions.length) {
                  regions.forEach((item) => {
                    if (item.regionCode === regKey) {
                      reg = item;
                    }
                  });
                }
                if (regKey === "77") {
                  setErrorMessage(
                    "Запись к врачу не доступна для данного региона"
                  );
                  selectRegion(reg);
                  return;
                }
                if (reg) {
                  selectRegion(reg);
                  startFourthStepLoading(reg.OKATO);
                }
              }, 100)
            }}
            errorLabel={
              errorMessage && (
                <Text style={styles.errorLabel} weight="regular">
                  {errorMessage}
                </Text>
              )
            }
          />
          {selectedRegion ? (
            <img
              src={CrossIcon}
              onClick={cleanSelectCallback}
              style={styles.imgClose}
              alt=""
            />
          ) : (
            ""
          )}
        </Div>
        {!isContentLoading ? <ServiceAvailabilityMessage /> : null}

        <Div style={styles.containerMedicalOrganisations}>
          {isContentLoading ? (
            <Div style={{ marginTop: "17.5vh" }}>
              <ScreenSpinner />
            </Div>
          ) : medicalOrganisations.length && !userChecks.error ? (
            medicalOrganisations.map(mapMedicalOrganisationToSimpleCell)
          ) : selectedRegion && !userChecks.error && sixthStepSuccess ? (
            <Text style={styles.emptyContentMessage}>
              Не удалось получить список организаций, попробуйте позже
            </Text>
          ) : (
            ""
          )}
        </Div>
      </Div>
    </Panel>
  );
};

const mapStateToProps = (state) => {
  return {
    firstStepSuccess: state.regionAndMedicalOrganisation.firstStepSuccess,
    secondStepSuccess:
      state.regionAndMedicalOrganisation.secondStepLoadingSuccess,
    thirdStepSuccess:
      state.regionAndMedicalOrganisation.thirdStepLoadingSuccess,
    fifthStepSuccess:
      state.regionAndMedicalOrganisation.fifthStepLoadingSuccess,
    regions: state.regionAndMedicalOrganisation.regions,
    selectedRegion: state.regionAndMedicalOrganisation.selectedRegion,
    errorMessage: state.regionAndMedicalOrganisation.errorMessage,
    medicalOrganisations:
      state.regionAndMedicalOrganisation.medicalOrganisations,
    userInfo: state.userInfo.userInfo,
    user: state.user,
    orderId: state.regionAndMedicalOrganisation.orderId,
    userChecks: state.regionAndMedicalOrganisation.userChecks,
    error: state.regionAndMedicalOrganisation.error,
    snils: state.snils.snils,
    showLoader: state.loader.showRegionsLoader,
    sixthStepSuccess:
      state.regionAndMedicalOrganisation.sixthStepLoadingSuccess,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearState: () => {
      dispatch(restartSteps());
    },
    goBack: () => {
      dispatch(setPreviousPanel());
      dispatch(restartSteps());
    },
    startFirstStepLoading: () => dispatch(startFirstStepLoading()),
    startSecondStepLoading: () => dispatch(startSecondStepLoading()),
    startThirdStepLoading: () => dispatch(startThirdStepLoading()),
    startFourthStepLoading: (OKATO) => dispatch(startFourthStepLoading(OKATO)),
    startFifthStepLoading: (...args) =>
      dispatch(startFifthStepLoading(...args)),
    startSixthStepLoading: (userInfo, orderId, selectedRegion, user) =>
      dispatch(startSixthStepLoading(userInfo, orderId, selectedRegion, user)),
    goToRegionSelectorPage: () => dispatch(setActivePanel(panels.regions)),
    goToMedicalOrganisationSelectorPage: () =>
      dispatch(setActivePanel(panels.medicalOrganisationSelector)),
    goToSearchPanel: () => dispatch(setActivePanel(panels.regionSearchPanel)),
    goToDoctorPanel: () => dispatch(setActivePanel(panels.doctor)),
    goToMoscowScenarioPanel: () =>
      dispatch(setActivePanel(panels.moscowRegionDoctorPanel)),
    selectMedicalOrganisation: (medicalOrganisation) =>
      dispatch(selectMedicalOrganisation(medicalOrganisation)),
    selectRegion: (region) => {
      dispatch(selectRegionAction(region));
      dispatch(selectMedicalOrganisation(null));
    },
    clearRegionAndMedicalOrganisation: () =>
      dispatch(clearRegionAndMedicalOrganisation()),
    clearMedicalOrganisationSelector: () =>
      dispatch(selectMedicalOrganisation(null)),
    setErrorMessage: (message) => dispatch(setErrorMessageAction(message)),
    cleanErrorMessage: () => dispatch(cleanErrorMessageAction()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegionAndMedicalOrganisation);
